import { Component, Input, OnInit } from '@angular/core';
import { PtlNotificationService, PtlNotificationStyle } from '@ptl/global-components';
import { SoaService } from '../../form-wrappers/soa-form/services/soa.service';
import { ScopeOfAppointment } from '../interfaces/SOA/scope-of-appointment.interface';

@Component({
    selector: 'app-soa-card',
    templateUrl: './soa-card.component.html',
    styleUrls: ['./soa-card.component.scss'],
    standalone: false
})
export class SoaCardComponent implements OnInit {

  @Input() soa: ScopeOfAppointment;
  @Input() agentEsoaLink: string;

  linkClicked: any;
  customerAction: any;
  agentAction: any;

  showLinkToAgentEsoa: boolean = false;
  showResendSoaLink: boolean = false;
  resendLinkLoading: boolean = false;

  constructor(
    private ptlNotificationService: PtlNotificationService,
    private soaService: SoaService
  ) {
  }

  ngOnInit(): void {
    this.getActionDates();
    this.initSoaStatus();
  }

  initSoaStatus() {
    if (this.linkClicked && this.customerAction) {
      this.showLinkToAgentEsoa = true;
    } 
    else if (!this.linkClicked) {
      this.showResendSoaLink = true;
    }
  }

  async resendCustomerSoa(event: Event) {
    event.preventDefault();
    event.stopPropagation();

    this.resendLinkLoading = true;

    this.soaService.resendSoa(this.soa.soaTokenId).then((response) => {
      if (response?.message === 'Email Sent Successfully') {
        this.ptlNotificationService.open({
          title: 'Success',
          content: 'Email has been sent successfully',
          primaryButtonText: 'Close',
          notificationStyle: PtlNotificationStyle.SUCCESS
        });
      }
      else {
        this.showResendLinkError();
      }
    })
    .catch(this.showResendLinkError)
    .finally(() => this.resendLinkLoading = false);
  }

  showResendLinkError() {
    this.ptlNotificationService.open({
      title: 'Error',
      content: 'An unknown problem occurred. Please try again later or contact support.',
      primaryButtonText: 'Close',
      notificationStyle: PtlNotificationStyle.DANGER
    });
  }

  getActionDates() {
    for (const click of this.soa.linkClicked) {
      this.linkClicked = [];
      this.linkClicked.push(click.actionDate);
    }
    for (const customerAction of this.soa.customerAction) {
      this.customerAction = [];
      this.customerAction.push(customerAction.actionDate);
    }
    for (const agentAction of this.soa.agentAction) {
      this.agentAction = [];
      this.agentAction.push(agentAction.actionDate);
    }
  }

  getHeadingColor(hasContents: boolean) {
    switch (hasContents) {
      case true: return '#85d8ae';
      case false: return '#bfe8f8';
      default: return '#bfe8f8';
    }
  }

  getArchivedHeaderColor() {
    if ((this.linkClicked?.length > 0) && (this.customerAction?.length > 0) && (this.agentAction?.length > 0)) {
      return '#85d8ae';
    } else {
      return '#bfe8f8';
    }
  }

}
